import React from "react";

import { useAndSetWidgets } from "@src/api/widgets/get-widgets";
import { IgErrorBoundary } from "@src/components/Utils/IgErrorBoundary";
import { useViewPage } from "@src/hooks/mixpanel";
import Loading from "@src/utils/Loading";

import { WidgetLibraryBody } from "./WidgetLibrary.body";

export const WidgetLibraryRoute = () => {
  const widgets = useAndSetWidgets();

  useViewPage("Global Styles");
  if (!widgets.isSuccess) {
    return <Loading />;
  }
  return (
    <IgErrorBoundary>
      <WidgetLibraryBody />
    </IgErrorBoundary>
  );
};
